<template>
  <div class="job-list-page">
    <div class="search-box">
      <el-input v-model="params.searchValue" placeholder="请输入职位、公司名称自动搜索" maxlength="20">
        <!--  @click="dialogVisible = true" -->
        <!-- <span slot="append" @click="autoSearch" >搜索</span> -->
      </el-input>
      <el-button class="job-search" type="primary" @click="autoSearch" :loading="loading">搜索</el-button>
    </div>

    <div class="condition-wrapper">
      <div class="condition-content">
        <div class="condition-box">
          <strong class="label">工作地点:</strong>
          <div class="condition-items">
            <span
              class="condition"
              v-for="item in workAddressList"
              :key="item.id"
              :class="{ active: item.dictKey === params.workAddressCode }"
              @click="handleConditionClick('workAddressCode', item.dictKey)"
            >{{ item.dictValue }}</span>
          </div>
        </div>
        <div class="condition-box">
          <strong class="label">工作经验:</strong>
          <div class="condition-items">
            <span
              class="condition"
              v-for="item in workYearList"
              :key="item.id"
              :class="{ active: item.dictKey === params.workYear }"
              @click="handleConditionClick('workYear', item.dictKey)"
            >{{ item.dictValue }}</span>
          </div>
        </div>
        <div class="condition-box">
          <strong class="label">薪资要求:</strong>
          <div class="condition-items">
            <span
              class="condition"
              v-for="item in salaryList"
              :key="item.id"
              :class="{ active: item.dictKey === params.salaryRange }"
              @click="handleConditionClick('salaryRange', item.dictKey)"
            >{{ item.dictValue }}</span>
          </div>
        </div>

        <div class="condition-box">
          <strong class="label">学历要求:</strong>
          <div class="condition-items">
            <span
              class="condition"
              v-for="item in educationList"
              :key="item.id"
              :class="{ active: item.dictKey === params.educationCode }"
              @click="handleConditionClick('educationCode', item.dictKey)"
            >{{ item.dictValue }}</span>
          </div>
        </div>
        <div class="condition-box">
          <strong class="label">所属行业:</strong>
          <div class="condition-items" :class="showActive?'industry-line-more':'industry-line-1'">
            <span
              class="condition"
              v-for="item in industryList"
              :key="item.id"
              :class="{ active: item.dictKey === params.industryCode }"
              @click="handleConditionClick('industryCode', item.dictKey)"
            >{{ item.dictValue }}</span>
          </div>
          <div class="more-condition u-flex" @click="handleMore">
            <div>更多</div>
            <div class="show-more iconfont icon-xiala" :class="showActive?'show':'hide'"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="job-list">
      <ul class="job-ul">
        <li v-for="item in jobList" :key="item.id" class="job-li">
          <div class="u-flex u-row-between">
            <router-link :to="`/portal/job/detail?id=${item.id}`" class="job-name">{{ item.name }}</router-link>
            <span class="u-font-18 error-color">{{ item.negotiable?'面议':item.salary }}</span>
          </div>
          <div class="u-flex u-row-between u-m-t-18">
            <div>
              <span class="text" v-if="item.workArea">{{ item.workArea }}</span>
              <span class="text" v-if="item.education">{{ item.education }}</span>
              <span class="text">{{ !item.workYears || item.workYears === '0' ? '经验不限' : `${item.workYears}年经验` }}</span>
              <span v-if="item.scale" class="text">{{ item.scale }}</span>
            </div>
            <div class="u-line-1" style="max-width: 360px;" :title="item.companyName">{{ item.companyName }}</div>
          </div>
        </li>
      </ul>
      <show-no-data text="暂未查到相关职位" v-show="jobList.length === 0" style="height: 400px;"></show-no-data>
      <div class="pagination-box">
        <el-pagination
          hide-on-single-page
          background
          layout="total, sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 40]"
          :current-page="params.current"
          :page-size="params.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { jobListUrl, dictionaryUrl } from '@/api'
import { backTopObj } from '@/utils'
export default {
  name: 'job-list',
  data() {
    return {
      showActive: false,
      loading: false,
      activeNames: '1',
      params: {
        educationCode: '',
        employmentModeCode: '',
        industryCode: '',
        salaryRange: '', // 1=不限 2=3K以下 3=3-5K 4=5-10K 5=10-20K 6=20-50K 7=50K以上
        searchValue: '',
        workAddressCode: '',
        workYear: '', // 1=1~3年 2=3~5年 3=5年以上
        current: 1,
        size: 10
      },
      jobList: [],
      total: 0,
      educationList: [], // 文化程度(数据字典)
      employmentList: [], // 用工方式(数据字典)
      industryList: [], // 所属行业(数据字典)
      workAddressList: [], // 工作地点(数据字典)
      salaryList: [
        { id: '1', dictKey: '', dictValue: '不限' },
        { id: '2', dictKey: '2', dictValue: '3k以下' },
        { id: '3', dictKey: '3', dictValue: '3-5k' },
        { id: '4', dictKey: '4', dictValue: '5-10k' },
        { id: '5', dictKey: '5', dictValue: '10-20k' },
        { id: '6', dictKey: '6', dictValue: '20-50k' },
        { id: '7', dictKey: '7', dictValue: '50k以上' }
      ],
      workYearList: [
        { id: '1', dictKey: '', dictValue: '不限' },
        { id: '2', dictKey: '1', dictValue: '1-3年' },
        { id: '3', dictKey: '2', dictValue: '3-5年' },
        { id: '4', dictKey: '3', dictValue: '5年以上' }
      ]
    }
  },
  // 初始化获取所有数据
  mounted() {
    this.loadData()
    this.getDictionary('AAC011')
    // this.getDictionary('YGFS00_NEW')
    this.getDictionary('CCH180')
    this.getDictionary('GZDD00_NEW')
    window.addEventListener('scroll', backTopObj.getScrollTop)
  },
  destroyed() {
    window.removeEventListener('scroll', backTopObj.getScrollTop)
  },
  methods: {
    async loadData(query) {
      if (query) {
        this.params.current = 1
      }
      try {
        let {
          data: { records, total }
        } = await this.$post(jobListUrl, this.params)
        if (this.loading) {
          this.loading = false
        }
        this.jobList = records.map(item => {
          item.education = item.educationCode && item.educationCode.dictValue
          item.salary = this.getSalary(item.salaryExpectationMin, item.salaryExpectationMax)
          item.workArea = item.workAddressCode.map(item => item.dictValue).join('，')
          item.scale = item.scaleCode && item.scaleCode.dictValue // 公司规模
          return item
        })
        this.total = total
        backTopObj.backTop()
      } catch (e) {
        this.loading = false
      }
    },
    // 获取薪资字符串
    getSalary(min, max) {
      let num1 = min ? (Number(min) / 1000).toString() : ''
      let num2 = max ? (Number(max) / 1000).toString() : ''
      if (num1.includes('.')) {
        num1 = num1.slice(0, num1.indexOf('.') + 2) // 如果小数点存在，则保留到小数点后一位数
      }
      if (num2.includes('.')) {
        num2 = num2.slice(0, num2.indexOf('.') + 2)
      }
      if (num1 && num2) {
        return `${num1}K-${num2}K`
      } else if (num1) {
        return `${num1}K以上`
      } else if (num2) {
        return `${num2}K以内`
      } else {
        return ''
      }
    },
    // 输入自动搜索
    autoSearch() {
      this.loading = true
      this.loadData('query')
    },
    // 点击查询条件
    handleConditionClick(key, dictKey) {
      this.params[key] = dictKey
      this.loadData('query')
    },

    // 获取数据字典
    async getDictionary(code) {
      let { data } = await this.$get(dictionaryUrl, { code })
      data.unshift({ id: '', dictKey: '', dictValue: '不限' })
      switch (code) {
        case 'AAC011': // 学历列表
          this.educationList = data
          break
        case 'YGFS00_NEW': // 用工方式
          this.employmentList = data
          break
        case 'CCH180':
          this.industryList = data
          break
        case 'GZDD00_NEW': // 工作地点
          this.workAddressList = data
          break
      }
    },
    handleCurrentChange(pageIndex) {
      this.params.current = pageIndex
      this.loadData()
    },
    handleSizeChange(pageSize) {
      this.params.size = pageSize
      this.loadData('query')
    },

    handleMore() {
      this.showActive = !this.showActive
    }
  }
}
</script>

<style lang="scss" scope>
.job-list-page {
  .search-box {
    height: 182px;
    background: url('../../../assets/img/banner.png') center/1920px 182px no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-input {
      width: 800px;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .el-input__inner {
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      border: 1px solid #fff;
    }
    .el-input-group__append {
      width: 140px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      padding: 0;
      text-align: center;
      background-color: $primary-color;
      color: #fff;
      cursor: pointer;
      border: 1px solid $primary-color;
      & > span {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .job-search {
      width: 140px;
      height: 48px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .job-list {
    width: 1200px;
    margin: 20px auto;
    background-color: #fff;
  }
  .job-ul {
    padding: 0 30px;
    background-color: #fff;
  }
  .job-li {
    padding: 30px 0;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    // &:hover {
    //   background-color: rgba(25, 40, 141, 0.5);
    // }
  }
  .job-name {
    font-size: 18px;
    &:hover {
      color: $primary-color;
      text-decoration: underline;
    }
  }
  .text {
    color: $text-color-secondary;
    padding: 0 20px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 14px;
      background-color: #cecece;
    }
    &:first-child {
      padding: 0 20px 0 0;
      &::before {
        content: none;
      }
    }
  }
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    background-color: #fff;
  }
}
.condition-wrapper {
  background-color: #fff;
  .condition-content {
    width: 1200px;
    margin: 0 auto;
    padding: 34px 0px 10px;
    box-sizing: border-box;
    .condition-box {
      display: flex;
      align-items: flex-start;
      margin-bottom: 14px;
      .label {
        white-space: nowrap;
        margin-right: 10px;
        line-height: 28px;
      }
      .condition-items {
        flex: 1;
        .condition {
          display: inline-flex;
          line-height: 28px;
          border-radius: 4px;
          padding: 0 12px;
          // background-color: #eee;
          margin: 0 10px 10px 0;
          cursor: pointer;
          transition: color 0.2s, background-color 0.2s;
          &:hover {
            color: $primary-color;
          }
          &.active {
            color: #fff;
            background-color: $primary-color;
          }
        }
      }
      .industry-line-1 {
        overflow: hidden;
        white-space: nowrap;
      }

      .more-condition {
        font-size: 14px;
        cursor: pointer;
        color: $primary-color;
        padding: 5px;
        margin-left: 15px;
        .show-more {
          transition: all 0.3s;
          font-size: 14px;
        }
        .show {
          transform: rotate(180deg);
        }
        .hide {
          transform: rotate(0deg);
        }
      }
    }
  }
}
</style>
